import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

function SlideCounter({ stepsData }) {
  const { step, totalSteps } = stepsData;
  return (
    <div
      className="mn_onboardingSlideCounter"
      data-steps-current={step}
      data-steps-total={totalSteps}
    >
      {step} of {totalSteps}
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><SlideCounter {...props} /></ComponentErrorBoundary>;
